
import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import ALMDashboard from '@/components/alm/ALMDashboard';
import ALMForecasting from '@/components/alm/forecasting/ALMForecasting';
import { Skeleton } from "@/components/ui/skeleton";
import LazyLoad from "@/components/LazyLoad";
import { toast } from "@/hooks/use-toast";

const ALM = () => {
  const [isLoading, setIsLoading] = useState(true);
  // Use a key with the current timestamp to force re-render
  const [refreshKey, setRefreshKey] = useState(Date.now());

  // Simulate faster initial load with shorter timeout
  React.useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 50); // Reduced from 100ms to 50ms for more responsive feel
    return () => clearTimeout(timer);
  }, []);

  // Force a complete refresh of all components
  useEffect(() => {
    // Stronger refresh mechanism
    const timer = setTimeout(() => {
      setRefreshKey(Date.now());
      // Notify user that data has been refreshed
      toast({
        title: "Data refreshed",
        description: "Contract identifier display has been updated",
      });
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="flex flex-col gap-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">ALM & Cash Position</h1>
        <p className="text-muted-foreground">
          Manage your asset-liability positions and optimize cash flows across time horizons
        </p>
      </div>

      {isLoading ? (
        <Card>
          <CardHeader>
            <Skeleton className="h-6 w-48" />
            <Skeleton className="h-4 w-96" />
          </CardHeader>
          <CardContent>
            <div className="w-full h-64 animate-pulse">
              <Skeleton className="w-full h-full" />
            </div>
          </CardContent>
        </Card>
      ) : (
        <Tabs defaultValue="dashboard" className="w-full" key={refreshKey}>
          <TabsList>
            <TabsTrigger value="dashboard">Dashboard</TabsTrigger>
            <TabsTrigger value="forecasting">Forecasting</TabsTrigger>
          </TabsList>
          
          <TabsContent value="dashboard" className="space-y-4">
            <LazyLoad delay={10}>
              <ALMDashboard key={refreshKey} />
            </LazyLoad>
          </TabsContent>
          
          <TabsContent value="forecasting" className="space-y-4">
            <LazyLoad delay={10}>
              <ALMForecasting />
            </LazyLoad>
          </TabsContent>
        </Tabs>
      )}
    </div>
  );
};

export default ALM;
